var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 40,
    viewBox: "0 0 19 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V26.5C0 31.7467 4.25329 36 9.5 36H17.2929L14.6464 38.6464C14.4512 38.8417 14.4512 39.1583 14.6464 39.3536C14.8417 39.5488 15.1583 39.5488 15.3536 39.3536L18.1464 36.5607C18.7322 35.9749 18.7322 35.0251 18.1464 34.4393L15.3536 31.6464C15.1583 31.4512 14.8417 31.4512 14.6464 31.6464C14.4512 31.8417 14.4512 32.1583 14.6464 32.3536L17.2929 35H9.5C4.80558 35 1 31.1944 1 26.5V0.5H0Z",
    fill: "#9BAEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefund);
export default __webpack_public_path__ + "static/media/IconRefund.6bc032178e2d0ffd7283756af7d0843b.svg";
export { ForwardRef as ReactComponent };